import { styled } from '@slal/ui';
import { InputGroup } from '@slal/ui/forms';
import { Text } from '@slal/ui/typography';
import { Field, Switch } from '~/components';

export const StyledField = styled(Field)`
    label {
        span {
            font-size: ${({ theme }) => theme.fontSizes[3]};
            color: ${({ theme }) => theme.colors.neutral__light__70};
            padding-bottom: 8px;
        }
    }
    div {
        flex: none;
    }
`;

export const StyledText = styled(Text)`
    color: ${({ theme }) => theme.colors.neutral__dark__30};
    font-size: ${({ theme }) => theme.fontSizes[3]};

    a {
        color: ${({ theme }) => theme.colors.aqua__70};
    }
`;

export const StyledInputGroup = styled(InputGroup)`
    label {
        min-width: 40px;
    }
    input {
        width: 100px;
    }
    input[name='investmentAmount'] {
        width: 140px;
    }
`;

export const FieldContentWrapper = styled('div')`
    display: flex;
    align-items: center;
`;

export const StyledSwitch = styled(Switch)`
    margin-left: 16px;
`;
